export const forms = {
    testdrive: document.forms.testdrive,
    "start-testdrive": document.forms["start-testdrive"],
};
